/*
 * nav/actions
 *
 * Actions are the only way the app should interact with redux state.
 */
import uuidv4 from "uuid/v4";

import {
  LOGIN_FAILED,
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGOUT_START,
  LOGOUT_SUCCESS
} from "./constants";

const nav = {};

nav.loginStart = () => ({
  type: LOGIN_START
});

nav.loginSuccess = user => ({
  type: LOGIN_SUCCESS,
  user
});

nav.loginFailed = error => ({
  type: LOGIN_FAILED,
  error: { id: uuidv4(), message: error.message, description: "Login failed." }
});

nav.logoutStart = () => ({
  type: LOGOUT_START
});

nav.logoutSuccess = () => ({
  type: LOGOUT_SUCCESS
});

export { nav };

export default nav;
